<script setup lang="ts">
    import KButton from "@/components/Button.vue";
    import { useStore } from "@/store";
    import Receptforskrivningsmallar from "@/tabs/Admin/Receptforskrivningsmallar.vue";

    const store = useStore();

    const openMallar = () => {
        store.dispatch("tabs/openTab", {
            component: Receptforskrivningsmallar,
        });
    };
</script>

<template>
    <KButton type="button" variant="contour" size="small" @click="openMallar">
        <img src="@/assets/gear_blue.svg" alt="Förskrivningsmallar" />
        <span>Förskrivningsmallar</span>
    </KButton>
</template>

<style scoped lang="scss"></style>
